<!--
  모바일웹 수강후기 컴포넌트
-->
<template>
  <section
    class="section_home review bg_gray"
    data-effect-slide="scroll"
  >
    <div class="inner">
      <div
        :id="slideId"
        :class="deviceType"
      >
        <div class="review_content">

          <h2 v-html="potltInfo.potltNm" />

          <!-- 리뷰 리스트 -->
          <div
            :class="['wrap_review_list']"
          >
            <div
              :class="['review_inner']"
              data-direction="next"
            />

            <!-- slide navigation -->
            <div class="slide_nav">
              <button
                class="btn_radial_slide prev"
                @click.prevent="changeFocusedIndex('prev')"
              >prev</button>
              <button
                class="btn_radial_slide next"
                @click.prevent="changeFocusedIndex('next')"
              >next</button>
            </div>
            <!-- // slide navigation -->

          </div>
          <!-- // 리뷰 리스트 -->

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import commonMixin from '@/mixin/commonMixin'

export default {
  name: 'ReviewCors',
  mixins: [commonMixin],
  props: {
    potltInfo: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      slideId: 'reviewRadialSlide',
      isFanUi: true, // 부채꼴 UI 여부 (PC 인 경우 true)
      item: {
        length: 0, // 데이터 갯수
        angle: 8, // 리뷰 슬라이드 이동시 변경되는 기본 각도 (Fan UI 전용)
        slideGap: 12, // 리뷰 슬라이드 간격 (list UI 전용)
        slideWidth: 0, // 리뷰 슬라이드 넓이
        focusedIndex: 0, // 현재 포커싱 되어 있는 index (기본값 0, rotate 실행시 값 업데이트 됨)
        maxReviewRate: 5, // 리뷰 만점 > 5 (이 값을 기준으로 상대적으로 별점 색상 채워짐)
        // 아이템 컬러 리스트
        chipColor: [
          '#206498',
          '#51C98A',
          '#D19A61',
          '#45C9E0',
          '#7B50B9',
          '#FFB750'
        ],
        applyRndColor: false, // 색상 랜덤 적용 여부
        data: null // 배너 데이터
      }
    }
  },
  computed: {
    isDesktop () {
      return window.vue.getStore('homeInfo').state.isDeskTopMode
    },
    // 현재 디바이스 명 (pc, mobile, tablet)
    deviceType () {
      return window.vue.getStore('homeInfo').state.deviceType
    }
  },
  watch: {
    isDesktop (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setFanClass()
        this.initReviewData() // 리뷰 데이터 초기화
      }
    }
  },
  mounted () {
    // // 포틀릿 데이터 조회
    // this.$http.b2c.portletData(this, { potltCd: this.potltInfo.potltCd, potltNo: this.potltInfo.potltNo, langCd: this.getUserLangCd() } ).then( (result) => {
    //   const data = result.data
    //   if ( data.status === 'OK' ) {
    //     console.log('portletData', data)
    //     this.isVisible = true
    //     this.potltData = data.data
    //   } else {
    //     // 데이터 없음
    //   }
    // })

    this.$nextTick(() => {
      if (this.potltInfo && this.potltInfo.potltData) {
        this.initRadialSlide() // 리뷰 슬라이드 실행
        this.setFanClass() // 부채꼴 UI 클래스 설정
        this.setSwipeEvent() // 모바일 터치 스와이프 이벤트
        this.getReviewData() // 리뷰 데이터 가져오기
        this.initReviewData() // 리뷰 데이터 초기화
      }
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setDeviceType, true)
  },
  methods: {
    // mo, pc 구분 (viewport width 기준)
    setDeviceType () {
      const vw = window.innerWidth

      if (vw >= 1200) {
        this.deviceType = 'pc'
      } else {
        if (vw <= 360) {
          this.deviceType = 'mobile'
        } else {
          this.deviceType = 'tablet'
        }
      }

      this.initRadialSlide() // 리뷰 슬라이드 실행
    },
    // 부채꼴 UI 클래스 설정
    setFanClass () {
      const fanEl = document.querySelector('.wrap_review_list')

      if (this.isDesktop) {
        fanEl.classList.add('fan')
        this.isFanUi = true
      } else {
        fanEl.classList.remove('fan')
        this.isFanUi = false
      }
    },
    // 터치 스와이프 이벤트
    setSwipeEvent () {
      const _this = this
      let pageWidth = window.innerWidth || document.body.clientWidth
      let treshold = Math.max(1, Math.floor(0.01 * (pageWidth)))
      let touchstartX = 0
      let touchstartY = 0
      let touchendX = 0
      let touchendY = 0

      const limit = Math.tan(45 * 1.5 / 180 * Math.PI)
      const gestureZone = document.querySelector('.wrap_review_list .review_inner')

      gestureZone.addEventListener('touchstart', function (event) {
        touchstartX = event.changedTouches[0].screenX
        touchstartY = event.changedTouches[0].screenY
      }, false)

      gestureZone.addEventListener('touchend', function (event) {
        touchendX = event.changedTouches[0].screenX
        touchendY = event.changedTouches[0].screenY
        handleGesture(event)
      }, false)

      function handleGesture (e) {
        let x = touchendX - touchstartX
        let y = touchendY - touchstartY
        let yx = Math.abs(y / x)
        if (Math.abs(x) > treshold || Math.abs(y) > treshold) {
          if (yx <= limit) {
            if (x < 0) {
              _this.changeFocusedIndex('next')
            } else {
              _this.changeFocusedIndex('prev')
            }
          }
        }
      }
    },
    // 배너 데이터 설정
    getReviewData () {
      // name의 짝수 번째 텍스트를 *로 변환
      function replaceEvenCharsWithAsterisks (name) {
        return name && name.length >= 2
          ? name.split('').map((char, index) => index % 2 === 1 ? '*' : char).join('')
          : name
      }

      if (this.potltInfo && this.potltInfo.potltData) {
        const result = this.potltInfo.potltData.map(({ corsNm: title, attltPscrtCntnt: desc, mbrFnm: name, lastUpdDtm: date, evalScore: rate, corsCd }) => {
          const userName = replaceEvenCharsWithAsterisks(name)

          return {
            title,
            desc,
            userName,
            date: this.dtmFormat(date, 'YYYY.MM.DD'),
            rate,
            corsCd
          }
        })

        this.item.data = result
        this.item.length = result.length
      }

      this.initReviewData()
    },

    // idx 기준 색상 코드 반환
    getColor (idx) {
      const arrColor = this.item.chipColor
      const colorListLength = arrColor.length
      let color

      if (idx >= colorListLength) {
        color = arrColor[idx - colorListLength]
      } else {
        color = arrColor[idx]
      }

      return color
    },
    // 랜덤 색상 코드
    getRndColor () {
      const arrColor = this.item.chipColor
      const _min = 0
      const _max = arrColor.length > 1 ? (arrColor.length - 1) : 0
      const rndNum = _max === 0 ? 0 : (Math.floor(Math.random() * (_max - _min + 1)) + _min)

      return arrColor[rndNum]
    },
    // 슬라이드 UI 초기화
    initRadialSlide () {
      this.getReviewData()
    },
    getItemTransitionData (idx, isVisibleItem) {
      const arrDataIndex = {
        visiblePc: [
          [-2, 'append'],
          [-1, 'append'],
          [0, 'append'],
          [1, 'append'],
          [2, 'append']
        ],
        visibleMo: [
          [-1, 'append'],
          [0, 'append'],
          [1, 'append']
        ],
        hiddenPc: [
          [3, 'append'],
          [-3, 'prepend']
        ],
        hiddenMo: [
          [2, 'append'],
          [-2, 'prepend']
        ]
      }
      const dataIndex = isVisibleItem ? this.deviceType === 'mobile' ? arrDataIndex.visibleMo : arrDataIndex.visiblePc : this.deviceType === 'mobile' ? arrDataIndex.hiddenMo : arrDataIndex.hiddenPc
      const ret = [
        dataIndex[idx][0],
        dataIndex[idx][1],
        dataIndex.length
      ]

      return ret
    },
    // 리뷰 아이템 엘리먼트 삽입
    appendReviewEl (isVisibleItem) {
      const reviewWrapper = document.querySelector('.wrap_review_list .review_inner')
      const focusedIndex = this.item.focusedIndex
      const dataLength = this.item.length

      // 데이터 유효성 검사
      if (!this.item.data || !Array.isArray(this.item.data)) {
        return
      }

      const visibleSlideLength = this.deviceType === 'mobile' ? 3 : 5 // 노출할 슬라이드 갯수
      const hiddenSlideLength = 2
      const slideWidth = this.item.slideWidth
      const slideLength = isVisibleItem ? visibleSlideLength : hiddenSlideLength
      const angle = this.item.angle
      const slideGapMo = this.item.slideGap
      let i, idx, pos, transitionData, transitionValue, tmpIndex, targetIndex, itemData, itemTemplate, reviewItem, reviewRate, progressWidth, color

      for (i = 0; i < slideLength; i++) {
        transitionData = this.getItemTransitionData(i, isVisibleItem)
        idx = transitionData[0]
        pos = transitionData[1]

        if (this.isDesktop) {
          transitionValue = angle * idx
        } else {
          transitionValue = this.item.slideWidth * idx + (slideGapMo * idx)
        }

        tmpIndex = focusedIndex + idx
        targetIndex = tmpIndex < 0 ? dataLength + tmpIndex : tmpIndex >= dataLength ? tmpIndex - dataLength : tmpIndex

        itemData = this.item.data[targetIndex]

        if (!itemData) {
          continue // 데이터가 유효하지 않으면 다음 루프로 이동
        }

        reviewRate = itemData.rate
        progressWidth = (reviewRate * 100 / this.item.maxReviewRate).toFixed(2)

        if (this.item.applyRndColor) {
          color = this.getRndColor()
        } else {
          color = this.getColor(targetIndex)
        }

        itemTemplate = `
          <span class="icon_comma" style="background-color:${color}">"</span>
          <a class="review_tit" href="course/crsDetail?corsCd=${itemData.corsCd}">${itemData.title}</a>
          <span class="review_desc">${itemData.desc}</span>
          <ul class="user_info">
            <li>${itemData.userName}</li>
            <li>${itemData.date}</li>
          </ul>
          <div class="review_rate">
            <div class="rate_icon">
              <div class="mask">
                <div class="progress" style="width:${progressWidth}%;background-color:${color}"></div>
              </div>
            </div>
            <span class="rate_txt">${reviewRate}</span>
          </div>
        `

        reviewItem = document.createElement('div')
        reviewItem.classList.add('review_item')
        if (!this.isFanUi) reviewItem.style.width = `${slideWidth}px`

        if (transitionValue === 0) reviewItem.classList.add('active')

        reviewItem.style.transform = this.isDesktop ? `rotate(${transitionValue}deg)` : `translateX(${transitionValue}px)`
        reviewItem.innerHTML = itemTemplate

        if (pos === 'append') {
          reviewWrapper.appendChild(reviewItem)
        } else {
          reviewWrapper.prepend(reviewItem)
        }
      }
    },
    // 화면에 노출되는 초기 리뷰 데이터 초기화
    initReviewData () {
      const reviewWrapper = document.querySelector('.wrap_review_list .review_inner')

      reviewWrapper.innerHTML = ''
      if (this.deviceType === 'mobile') {
        this.item.slideWidth = Math.floor(window.innerWidth - 54)
      } else {
        this.item.slideWidth = Math.floor((window.innerWidth - 78) / 3)
      }

      this.appendReviewEl(true) // 화면에 노출되는 데이터 설정
      this.setHiddenReviewData() // 화면에 노출되지 않는 데이터 설정
    },
    // 화면에 노출되지 않는(좌우에 숨겨진) 리뷰 데이터 설정
    setHiddenReviewData (dir) {
      const reviews = document.querySelectorAll('.wrap_review_list .review_item')
      const reviewsMaxLength = this.deviceType === 'mobile' ? 3 : 5

      if (reviews.length > reviewsMaxLength) {
        let arrRemoveIndex = [0, reviewsMaxLength + 1]
        if (dir !== undefined) {
          if (dir === 'prev') {
            arrRemoveIndex = [reviewsMaxLength, reviewsMaxLength + 1]
          } else {
            arrRemoveIndex = [0, 1]
          }
        }

        for (let i = 0; i < arrRemoveIndex.length; i++) {
          if (reviews[arrRemoveIndex[i]]) reviews[arrRemoveIndex[i]].remove()
        }
      }

      this.appendReviewEl(false)
    },
    // // prev, next 버튼 존재 여부 리턴
    buttonExists: function () {
      const btnWrapper = document.querySelector('.wrap_review_list .slide_nav')
      const btns = document.querySelectorAll('.wrap_review_list .slide_nav .btn_radial_slide')
      let ret = false

      if (btnWrapper && btns.length > 0) ret = true
      return ret
    },
    // prev, next 버튼 비활성
    buttonDisabled: function () {
      if (this.buttonExists()) {
        const btns = document.querySelectorAll('.wrap_review_list .slide_nav .btn_radial_slide')
        let i, btn

        for (i = 0; i < btns.length; i++) {
          btn = btns[i]
          btn.disabled = true
        }
      }
    },
    // prev, next 버튼 활성
    buttonEnabled: function () {
      if (this.buttonExists()) {
        const btns = document.querySelectorAll('.wrap_review_list .slide_nav .btn_radial_slide')
        let i, btn

        for (i = 0; i < btns.length; i++) {
          btn = btns[i]
          btn.disabled = false
        }
      }
    },
    // 리뷰 아이템 rotate 값 리턴 (PC)
    getRotationValue (reviewEl, dir) {
      const angle = this.item.angle
      const st = window.getComputedStyle(reviewEl, null)
      const trv = st.getPropertyValue('-webkit-transform') || st.getPropertyValue('-moz-transform') || st.getPropertyValue('-ms-transform') || st.getPropertyValue('-o-transform') || st.getPropertyValue('transform') || undefined

      let values = trv.split('(')[1]
      values = values.split(')')[0]
      values = values.split(',')

      const a = values[0]
      const b = values[1]
      const scale = Math.sqrt(a * a + b * b)
      const sin = b / scale
      const currentValue = Math.round(Math.asin(sin) * (180 / Math.PI))
      const newValue = dir === 'prev' ? currentValue + angle : currentValue - angle

      if (newValue === 0) {
        reviewEl.classList.add('active')
      } else {
        reviewEl.classList.remove('active')
      }

      reviewEl.style.transform = `rotate(${newValue}deg)`
    },
    // 리뷰 아이템 translateX 값 리턴 (MO)
    getTranslateValue (reviewEl, dir) {
      const slideWidth = this.item.slideWidth
      const slideGap = this.item.slideGap
      const st = window.getComputedStyle(reviewEl)
      const matrix = new DOMMatrixReadOnly(st.transform)
      const currentValue = matrix.m41
      let newValue

      newValue = (dir === 'prev') ? currentValue + slideWidth + slideGap : currentValue - slideWidth - slideGap

      reviewEl.style.width = `${slideWidth}px`

      if (newValue === 0) {
        reviewEl.classList.add('active')
      } else {
        reviewEl.classList.remove('active')
      }

      reviewEl.style.transform = `translateX(${newValue}px)`
    },
    // 중앙에 위치할 리뷰 아이템 교체
    changeFocusedIndex (dir) {
      const _this = this
      const focusedIndex = this.item.focusedIndex
      const realIndex = focusedIndex + 1
      const dataLength = this.item.length
      const reviewWrapper = document.querySelector('.wrap_review_list .review_inner')
      const reviews = document.querySelectorAll('.wrap_review_list .review_item')
      let targetIndex, i, reviewEl

      this.buttonDisabled()

      reviewWrapper.setAttribute('data-direction', dir)

      if (dir === 'prev') {
        targetIndex = focusedIndex === 0 ? dataLength - 1 : focusedIndex - 1
      } else {
        targetIndex = realIndex === dataLength ? 0 : focusedIndex + 1
      }

      this.item.focusedIndex = targetIndex

      for (i = 0; i < reviews.length; i++) {
        reviewEl = reviews[i]
        this.isDesktop ? this.getRotationValue(reviewEl, dir) : this.getTranslateValue(reviewEl, dir)
      }

      // transition이 완료되는 시점에 숨은 영역 아이템 채우고 버튼 활성 처리
      setTimeout(function () {
        _this.setHiddenReviewData(dir)
        _this.buttonEnabled()
      }, 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/ReviewCors.vue